import React from 'react';
import PropTypes from 'prop-types';
import { withContent } from 'components/Content';
import Button from 'components/ContentfulFields/Button';
import { find } from 'lodash';
import { hasBrandTag } from 'components/Content/utils';

import styles from './styles.scss';

const CONTENT_KEYS = {
  title: 'Title',
  features: 'Features',
};

const ProductShowcase = ({ content }) => (
  <section className={styles.productShowcase}>
    <h2>{content.title}</h2>
    <ul>
      {content.features.fields.features.map((document) => {
        const brandImage = find(document.fields.brandedImages, (i) =>
          hasBrandTag(i),
        );
        return (
          <li key={document.sys.id}>
            <img
              src={`${brandImage.fields.file.url}?fm=webp`}
              alt={brandImage.fields.description || ''}
              aria-hidden="true"
            />
            <h3>{document.fields.title}</h3>
            <Button
              document={document.fields.carouselButton}
              className={styles.btn}
            />
          </li>
        );
      })}
    </ul>
  </section>
);

ProductShowcase.propTypes = {
  content: PropTypes.object,
};

export default withContent(CONTENT_KEYS)(ProductShowcase);
